var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yd-slider',{attrs:{"autoplay":"3000"}},[_c('yd-slider-item',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":require('@/assets/smskb-discovery-img/banner-smskb.jpg')}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }